import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { CidadeRoutingModule } from './cidade-routing.module';
import { CidadeComponent } from './cidade.component';
import { CidadeFormComponent} from './form';
import { CidadeSubRegiaoComponent, CidadeSubRegiaoFormComponent } from './sub-regiao';
import { CidadeSubRegiaoBairroComponent } from './bairro';
import { TypeaheadCidadeComponent } from './typeahead';

import { CidadeClassificacaoAbcPipe } from './pipes';
import { CidadeFilterCollapseComponent } from './filter';

@NgModule({
    imports: [
        SharedModule,
        TypeaheadModule.forRoot(),
        CidadeRoutingModule
    ],
    declarations: [
        CidadeComponent,
        CidadeFormComponent,
        CidadeSubRegiaoComponent,
        CidadeSubRegiaoFormComponent,
        CidadeSubRegiaoBairroComponent,
        TypeaheadCidadeComponent,
        CidadeFilterCollapseComponent,

        // Pipes
        CidadeClassificacaoAbcPipe
    ],
    exports: [
        TypeaheadCidadeComponent,

        // Pipes
        CidadeClassificacaoAbcPipe
    ],
    providers: [
        // Pipes
        CidadeClassificacaoAbcPipe
    ]
})
export class CidadeModule { }
